import * as Yup from "yup";

export default Yup.object().shape({
    imageUrl: Yup.string().nullable(),
    firstname: Yup.string().required("First name is required"),
    lastname: Yup.string().required("Last name is required"),
    email: Yup.string()
        .email("Wrong email format")
        .required("Email is required"),
    username: Yup.string()
        .required("Username is required"),
    phoneNumber: Yup.string().required("Phone is required"),
    password: Yup.string()
        .required('Enter a password')
        .min(5, "Minimum length of Password is 5"),
    confirmPassword: Yup.string()
        .required('Enter a Confirm Password')
        .oneOf([Yup.ref('password')], "Passwords does not match"),
    dateOfBirth: Yup.string()
        .required('Date of Birth is required'),
    isActive: Yup.bool(),
    ssn: Yup.string(),
    hourlyRate: Yup.number(),
    role: Yup.string(),
    address1: Yup.string(),
    address2: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    zipCode: Yup.string(),
    TWICPin: Yup.string(),
    payloadValidator: Yup.number().nullable(),
    safetyCouncilStudentId: Yup.string(),
    driverLicenseNumber: Yup.string(),
    DISAId: Yup.string(),
    AIId: Yup.string()
});